import angular from 'angular';

import './create/controller';
import './list/controller';

angular.module("merchant.application.module.invoicingEmail", [
]).controller("merchant.application.module.invoicingEmail.controller", [
    "$scope",
    function($scope) {

        if (! $scope.model) {
            $scope.model = {};
        }

    }
]);
